module.exports = __webpack_public_path__ + "assets/425070ad1bd4e1b18b6a0b5a75e92d89.mp3";